import React from 'react';
import style from './contactOwnerButton.scss';
import {
  ContactOwnerBlue,
  ContactOwnerWhite,
} from '../../../../../../PageElements/svgs';

export const ContactOwnerButton = ({
  onMouseEnter,
  onMouseLeave,
  onClick,
  isSelectedMode,
}) => {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${style.contactOwnerButton} ${
        isSelectedMode ? style.selected : ''
      }`}
      onClick={onClick}
      data-hook="contact-owner-button"
    >
      {isSelectedMode ? <ContactOwnerWhite /> : <ContactOwnerBlue />}
    </div>
  );
};
